import React from "react";
import { useTranslation } from "react-i18next";
import ButtonIconMC from "../../components/ButtonIconMC";
import DropdownButton from "../../components/DropdownButtonMC";
import IconMC from "../../components/IconMC";

const CreateFunnelStepItem = ({
  type,
  data,
  onPressEdit,
  onPressDelete,
  onChange
}) => {
  const { t } = useTranslation('Funnels');
  const handleEditStep = () => {
    onPressEdit(type, data);
  };
  const handleDeleteStep = () => {
    onPressDelete(type, data);
  };

  const items = [
    { icon: 'stash-thumb-up', onClick: () => onChange(type, { ...data, qualification: 'won' }) },
    { icon: 'stash-thumb-down', onClick: () => onChange(type, { ...data, qualification: 'lost' }) }
  ];

  const qualification = data?.qualification;

  const renderContent = () => <IconMC name={`stash-thumb-${qualification === 'won' ? 'up' : 'down'}`} size="base" />;

  const qualificationClassName = qualification === 'won' ? '!tw-bg-green-50 !tw-text-green-400' : '!tw-bg-red-50 !tw-text-red-400';

  return (
    <div className="tw-border tw-bg-white tw-border-gray-200 tw-flex tw-flex-1 tw-h-10 tw-items-center tw-rounded-xl">
      <div className="tw-flex tw-flex-1 tw-pl-5 tw-pr-3 tw-items-center">
        <div className="tw-flex-1">
          <span>{data.name}</span>
        </div>
        <ButtonIconMC
          icon="eye-outline"
          label={t('sidebar.createFromZero.stepTwo.editButton')}
          onClick={handleEditStep}
          iconClassName="tw-text-gray-500"
        />
        <ButtonIconMC
          icon="trash-2-outline"
          label={t('sidebar.createFromZero.stepTwo.removeButton')}
          onClick={handleDeleteStep}
          iconClassName="tw-text-gray-500"
        />
      </div>
      {type === 'closedSteps' && (
        <div>
          <DropdownButton
            items={items}
            renderContent={renderContent}
            className={`tw-gap-1 !tw-px-2 tw-h-[38px] tw-rounded-xl tw-rounded-l-none ${qualificationClassName}`}
            iconClassName="!tw-h-4 !tw-w-4 "
          />
        </div>
      )}
    </div>
  );
};

export default CreateFunnelStepItem;
